import { ReactNode } from "react";

export interface SectionProps {
  title?: string;
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
}
export default function Section(props: SectionProps) {
  return (
    <div className="bg-white rounded-lg">
      {(props.header || props.title) && (
        <div id="header" className="flex p-4 gap-2 border-b-light-1" style={{ borderBottom: "2px solid" }}>
          {props.header || (props.title && <span>{props.title}</span>)}
        </div>
      )}
      <div className="p-2 md:p-4">{props.children}</div>
      {props.footer && (
        <div id="footer" className="flex p-4 gap-2 border-t-light-1" style={{ borderTop: "2px solid" }}>
          {props.footer}
        </div>
      )}
    </div>
  );
}
